import React from 'react'
import { FilterContainer } from './FilterContainer'
import { LinksContainer } from './LinksContainer'
import PeopleContainer from './PeopleContainer'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'

export default class App extends React.Component {
  render() {
    return (
      <div id="body_section" className="d-flex mt-5">
        <ButterToast
          position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
          style={{ top: '65px' }}
        />
        <div className="contentLeft maxw-300px w-100 ml-5">
          <div>
            <FilterContainer />
          </div>
          <div>
            <LinksContainer />
          </div>
        </div>
        <div className="mainContent minw-600px w-100 mx-5">
          <PeopleContainer />
        </div>
      </div>
    )
  }
}
